import { string, shape, arrayOf, oneOf, exact } from 'prop-types';
import { SUPPORTED_CARDS } from 'common/constants/payment';
import modifierTypes from '../common/propTypes/modifierTypes';

export interface CardFormat {
  brands: 'AMEX' | 'MasterCard' | 'VISA';
  cardPrefix: string;
}

export const brandType = exact(
  Object.entries(SUPPORTED_CARDS).reduce((acc, [key, value]) => {
    acc[key] = oneOf([value]);
    return acc;
  }, {})
);

export const cardFormatType = shape({
  brands: brandType.isRequired,
  cardPrefix: string.isRequired,
});

export const restaurantType = shape({
  name: string.isRequired,
  address: shape({
    line1: string.isRequired,
    postalCode: string,
    city: string.isRequired,
    countryCode: string.isRequired,
  }).isRequired,
});

export const ordersType = shape({
  items: arrayOf(modifierTypes),
  tableNumber: string,
});

export interface BillItem {
  id: string;
  itemName: string;
  itemUnavailable: boolean;
  modifiers: any;
  posId: string;
  price: number;
  quantity: number;
  sortOrder: number;
  uniqueIds: string[];
  isDiscountItem?: boolean;
  originalPrice?: number;
}
